/** `toLineInput` on its own with no runtime imports (`ApiLogLine` is type-only): `time.ts` pulls in `./api` and MSAL, which touch `window`, and vitest runs in `node`. */
import type { ApiLogLine } from './time'

/**
 * The line exactly as `TimeLogIn` declares it, an ALLOWLIST: `id` and the derived display `activity` are not accepted,
 * and a denylist would let any future display-only field ride along on every save.
 */
export type LineInput = Pick<
  ApiLogLine,
  | 'market'
  | 'activity_id'
  | 'product_service_id'
  | 'shift'
  | 'work_mode'
  | 'hours'
  | 'overtime_hours'
  | 'nighttime_hours'
  | 'over_night_hours'
  | 'transit_hours'
  | 'comment'
>

export function toLineInput(line: ApiLogLine): LineInput {
  return {
    market: line.market,
    activity_id: line.activity_id,
    product_service_id: line.product_service_id,
    shift: line.shift,
    work_mode: line.work_mode,
    hours: line.hours,
    overtime_hours: line.overtime_hours,
    nighttime_hours: line.nighttime_hours,
    over_night_hours: line.over_night_hours,
    transit_hours: line.transit_hours,
    comment: line.comment,
  }
}
